import { isAuthDevBypass } from '@/config/env/auth'
import { getWorkspacesMode } from '@/config/env/workspaces'

export function workspaceRepositoryUsesLocal(mode = getWorkspacesMode()) {
  if (mode === 'local') return true
  if (mode === 'api') return false
  return isAuthDevBypass()
}
